<template>
	<div>
		<case-form :schema="identification" />

		<div class="fs4 fw7 lh125 mt6 mb2">
			医生/ 诊所/医院信息
		</div>
		<case-form :schema="doctorInformation" />

		<div class="fs4 fw7 lh125 mt6 mb2">
			如果您没有家庭医生或健康护理顾问，请提供您上次咨询的任何医疗诊所，健康护理顾问或医院以及原因。
		</div>
		<case-form :schema="specialistInformation" />
	</div>
</template>

<script>
import CaseForm from "@/modules/caseManagement/components/CaseForm/CaseForm.vue"
export default {
	components: {
		CaseForm
	},

	data() {
		return {}
	},

	computed: {
		identification() {
			return [
				{
					label: "政府身分证号码",
					component: "entityIdentity",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].identities",
					bindTo: `case.facts.insured0governmentIdNumberCN`,
					props: {
						suggest: {
							typeIncludes: "governmentIdNumberCN"
						},
						createOptions: {
							type: "governmentIdNumberCN"
						}
					}
				},
				{
					label: "签发国家",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0governmentIdCountryOfIssueCN`,
					props: {
						suggest: {
							typeIncludes: `governmentIdCountryOfIssueCN`
						},
						createOptions: {
							type: `governmentIdCountryOfIssueCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "护照号码",
					component: "entityIdentity",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].identities",
					bindTo: `case.facts.insured0passportNumberCN`,
					props: {
						suggest: {
							typeIncludes: "passportNumberCN"
						},
						createOptions: {
							type: "passportNumberCN"
						}
					}
				},
				{
					label: "签发国家",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0passportCountryOfIssueCN`,
					props: {
						suggest: {
							typeIncludes: `passportCountryOfIssueCN`
						},
						createOptions: {
							type: `passportCountryOfIssueCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "有效期至",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0identificationDateOfExpirationCN`,
					props: {
						suggest: {
							typeIncludes: `identificationDateOfExpirationCN`
						},
						createOptions: {
							type: `identificationDateOfExpirationCN`,
							dataType: "date"
						}
					}
				}
			]
		},

		doctorInformation() {
			return [
				{
					label: `家庭医生或医疗保健顾问名`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0personalDoctorFirstNameCN`,
					props: {
						suggest: {
							typeIncludes: `personalDoctorFirstNameCN`
						},
						createOptions: {
							type: `personalDoctorFirstNameCN`,
							dataType: "string"
						}
					}
				},
				{
					label: `家庭医生或医疗保健顾问姓`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0personalDoctorLastName`,
					props: {
						suggest: {
							typeIncludes: `personalDoctorLastNameCN`
						},
						createOptions: {
							type: `personalDoctorLastNameCN`,
							dataType: "string"
						}
					}
				},
				{
					label: `诊所或医院名称`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0personalDoctorHospitalCN`,
					props: {
						suggest: {
							typeIncludes: `personalDoctorHospitalCN`
						},
						createOptions: {
							type: `personalDoctorHospitalCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "地址",
					component: "entityAddress",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].addresses",
					bindTo: "case.facts.insured0personalDoctorAddressCN",
					props: {
						suggest: {
							typeIncludes: "personalDoctorAddressCN"
						},
						createOptions: {
							type: "personalDoctorAddressCN"
						}
					}
				},
				{
					label: `档案名字（如果与法定姓名不一致）`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0personalDoctorNameOnFileCN`,
					props: {
						suggest: {
							typeIncludes: `personalDoctorNameOnFileCN`
						},
						createOptions: {
							type: `personalDoctorNameOnFileCN`,
							dataType: "string"
						}
					}
				},
				{
					label: `上一次问诊日期`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0personalDoctorDateLastVisitedCN`,
					props: {
						suggest: {
							typeIncludes: `personalDoctorDateLastVisitedCN`
						},
						createOptions: {
							type: `personalDoctorDateLastVisitedCN`,
							dataType: "date"
						}
					}
				},
				{
					label: `上一次问诊原因`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0personalDoctorReasonForLastConsultationCN`,
					props: {
						suggest: {
							typeIncludes: `personalDoctorReasonForLastConsultationCN`
						},
						createOptions: {
							type: `personalDoctorReasonForLastConsultationCN`,
							dataType: "string"
						}
					}
				},
				{
					label: `治疗或处方药物和所有检测的结果`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0personalDoctorPrescriptionCN`,
					props: {
						suggest: {
							typeIncludes: `personalDoctorPrescriptionCN`
						},
						createOptions: {
							type: `personalDoctorPrescriptionCN`,
							dataType: "string"
						}
					}
				}
			]
		},

		specialistInformation() {
			return [
				{
					label: `家庭医生或医疗保健顾问名`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0otherDoctorFirstNameCN`,
					props: {
						suggest: {
							typeIncludes: `otherDoctorFirstNameCN`
						},
						createOptions: {
							type: `otherDoctorFirstNameCN`,
							dataType: "string"
						}
					}
				},
				{
					label: `家庭医生或医疗保健顾问姓`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0otherDoctorLastNameCN`,
					props: {
						suggest: {
							typeIncludes: `otherDoctorLastNameCN`
						},
						createOptions: {
							type: `otherDoctorLastNameCN`,
							dataType: "string"
						}
					}
				},
				{
					label: `治疗或处方药物和所有检测的结果`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0otherDoctorSpecialityCN`,
					props: {
						suggest: {
							typeIncludes: `otherDoctorSpecialityCN`
						},
						createOptions: {
							type: `otherDoctorSpecialityCN`,
							dataType: "string"
						}
					}
				},
				{
					label: `诊所或医院名称`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0otherDoctorHospitalCN`,
					props: {
						suggest: {
							typeIncludes: `otherDoctorHospitalCN`
						},
						createOptions: {
							type: `otherDoctorHospitalCN`,
							dataType: "string"
						}
					}
				},
				{
					label: "地址",
					component: "entityAddress",
					entity: "case.holder",
					relation: "case.insureds[0].addresses",
					bindTo: "case.facts.insured0specialistDoctorAddressCN",
					props: {
						suggest: {
							typeIncludes: "specialistDoctorAddressCN"
						},
						createOptions: {
							type: "specialistDoctorAddressCN"
						}
					}
				},
				{
					label: `档案名字（如果与法定姓名不一致）`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0otherDoctorNameOnFileCN`,
					props: {
						suggest: {
							typeIncludes: `otherDoctorNameOnFileCN`
						},
						createOptions: {
							type: `otherDoctorNameOnFileCN`,
							dataType: "string"
						}
					}
				},
				{
					label: `上一次问诊日期`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0otherDoctorDateLastVisitedCN`,
					props: {
						suggest: {
							typeIncludes: `otherDoctorDateLastVisitedCN`
						},
						createOptions: {
							type: `otherDoctorDateLastVisitedCN`,
							dataType: "date"
						}
					}
				},
				{
					label: `上一次问诊原因`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0otherDoctorReasonForLastConsultationCN`,
					props: {
						suggest: {
							typeIncludes: `otherDoctorReasonForLastConsultationCN`
						},
						createOptions: {
							type: `otherDoctorReasonForLastConsultationCN`,
							dataType: "string"
						}
					}
				},
				{
					label: `治疗或处方药物和所有检测的结果`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0otherDoctorPrescriptionCN`,
					props: {
						suggest: {
							typeIncludes: `otherDoctorPrescriptionCN`
						},
						createOptions: {
							type: `otherDoctorPrescriptionCN`,
							dataType: "string"
						}
					}
				}
			]
		}
	}
}
</script>
